import { waitForParams } from './piano';

export const dispatchEventToParent = async (eventName: string, data: any) => {
  if (!window.parent) {
    throw new Error(
      'FLMPiano.dispatchEventToParent: cannot dispatch event to parent because it is not available',
    );
  }

  const pianoParams = await waitForParams();
  const { displayMode, iframeId } = pianoParams;

  const message = {
    displayMode,
    event: 'flmpiano:customEvent',
    params: {
      eventName,
      params: {
        ...data,
        params: JSON.stringify(pianoParams), // for consistency with Piano's external event shape
      },
    },
    recipient: 'opener',
    sender: iframeId,
  };

  await sendMessageToParent(message);
};

const getParentOrigin = async () => {
  const { url } = await waitForParams();
  const { origin } = new URL(url);

  return origin;
};

export const isMessageFromParent = async (event: MessageEvent) => {
  const parentOrigin = await getParentOrigin();

  return event.origin === parentOrigin;
};

export const sendMessageToParent = async (message: any) => {
  const parentOrigin = await getParentOrigin();

  window.parent.postMessage(JSON.stringify(message), parentOrigin);
};
